export default "__VITE_ASSET__CnajUge0__"